export default "__VITE_ASSET__CHSBR4TR__"